import { useEffect, useRef } from "react";

const useDelayedAction = (delay: number, actionCb: () => void, executeCondition = true) => {
    const actionCbRef = useRef(actionCb);

    useEffect(() => {
        actionCbRef.current = actionCb;
    }, [actionCb]);

    useEffect(() => {
        let timeoutID: ReturnType<typeof setTimeout>;

        if (executeCondition) {
            timeoutID = setTimeout(actionCbRef.current, delay);
        }

        return () => {
            if (typeof timeoutID !== "undefined") {
                clearTimeout(timeoutID);
            }
        };
    }, [delay, executeCondition]);
};

export default useDelayedAction;
